// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"00f0abb3","239":"c62e1796","453":"3430075b","455":"5c5b9df6"}[chunkId] + ".chunk.js";
};